import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptor } from "src/utils/baseQuery";
import { TransporterVehiclesInterface } from "src/services/transporterVehicles/transporterVehicleSlice";

interface UpdateTransporterVehicles {
  id: string;
  data: Partial<TransporterVehiclesInterface>;
}
export const TransportVehicleApi = createApi({
  reducerPath: "TransporterVehiclesApi",
  baseQuery: baseQueryWithInterceptor,
  tagTypes: ["TransporterVehicles"],
  endpoints: (builder) => ({
    // getTransporterVehiclesById: builder.query<TransporterVehiclesInterface, string>({
    //   query: (id) => ({
    //     headers: {
    //       "Content-type": "application/json",
    //     },
    //     url: `organization/${id}`,
    //     method: "GET",
    //   }),
    // }),
    getVehicleById: builder.query<any, string>({
      query: (id) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `vehicle?_id=${id}`,
        method: "GET",
      }),
    }),
    
    getVehiclesList: builder.query<any, void>({
      query: (companyId) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `vehicle?company=${companyId}`,
        method: "GET",
      }),
    }),
    getTrailersList: builder.query<any, void>({
      query: (companyId) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `trailer?transportCompany=${companyId}`,
        method: "GET",
      }),
    }),
    addVehicle: builder.mutation<any, void>({
      query: (data) => ({
        headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        url: `vehicle`,
        method: "POST",
        body: data,
    }),
    }),
    updateVehicle: builder.mutation<any, any>({
      query: ({data, id}) => ({
        headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        url: `vehicle/${id}`,
        method: "PATCH",
        body: data,
    }),
    }),
    deleteVehicle: builder.mutation<any, any>({
      query: ({id}) => ({
        headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        url: `vehicle/${id}`,
        method: "DELETE",
    }),
    }),
    addTrailer: builder.mutation<any, any>({
      query: (data) => ({
        headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        url: `trailer/`,
        method: "POST",
        body: data,
    }),
    }),
    updateTrailer: builder.mutation<any, any>({
      query: ({data, id}) => ({
        headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        url: `trailer/${id}`,
        method: "PATCH",
        body: data,
    }),
    }),
    deleteTrailer: builder.mutation<any, any>({
      query: ({id}) => ({
        headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        url: `trailer/${id}`,
        method: "DELETE",
    }),
    }),
    searchVehicle: builder.query<any, any>({
      query: ({companyId, search}) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `vehicle/search?company=${companyId}&vehicle=${search}`,
        method: "GET",
      }),
    }),
    // getVehiclesByCompanyId: builder.query<any,str
    patchCompanyById: builder.mutation<any, any>({
      query: ({id,data}) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `company/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
    patchTransporterVehiclesById: builder.mutation<
      TransporterVehiclesInterface,
      UpdateTransporterVehicles
    >({
      query: ({ id, data }) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `organization/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetVehicleByIdQuery,
  useGetVehiclesListQuery,
  useSearchVehicleQuery,
  usePatchCompanyByIdMutation,
  usePatchTransporterVehiclesByIdMutation,
  useAddVehicleMutation,
  useUpdateTrailerMutation,
  useUpdateVehicleMutation,
  useDeleteVehicleMutation,
  useDeleteTrailerMutation,
  useAddTrailerMutation,
  useGetTrailersListQuery
} = TransportVehicleApi;
